import {
  Component,
  OnInit,
  ViewChild,
  Input,
  ElementRef,
  OnDestroy,
  EventEmitter,
  Output,
  SimpleChanges,
} from "@angular/core";
import Cropper from "cropperjs";
import { FilesService } from "@services/generic/files.service";
import { ExperiencesService } from "@services/experience/experiences.service";
import { ReplaySubject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { SavingEmitterService } from "src/app/services/emitters/saving-emitter.service";

@Component({
  selector: "image-cropper",
  templateUrl: "./image-cropper.component.html",
  styleUrls: ["./image-cropper.component.scss"],
})
export class ImageCropperComponent implements OnDestroy, OnInit {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  @ViewChild("image")
  public imageElement: ElementRef;

  @Input("src")
  public imageSource: string = "";

  @Input("experience")
  public experienceId: string;

  @Input("multipleImages")
  public multipleImages: boolean;

  @Input("activeCoverImage")
  public activeCoverImage: string;

  @Input("loadedImages")
  public loadedImages: Array<any>;
  public loadedImagePointer: number = 0;
  public galleryImages: Array<any> = [];
  public imageDestination: string;
  public croppedImage: FormData;
  public coverSet: boolean = false;
  private cropper: Cropper;
  @Output() coverImage = new EventEmitter<string>();
  constructor(
    private filesSvc: FilesService,
    private experienceSvc: ExperiencesService,
    private savingEmitter: SavingEmitterService
  ) {
    this.imageDestination = "";
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.cropper) {
      this.coverSet = false;

      this.cropper.replace(this.imageSource);
    }
  }

  public ngAfterViewInit() {
    this.cropper = new Cropper(this.imageElement.nativeElement, {
      zoomable: false,
      scalable: false,
      viewMode: 1,
      aspectRatio: 16 / 9,
      cropBoxResizable: true,

      cropend: () => {
        this.createCroppedImage();
      },

      ready: () => {
        this.createCroppedImage();
      },
    });
  }

  createCroppedImage() {
    let file = new FormData();
    this.cropper.getCroppedCanvas().toBlob(function (blob) {
      file.append("image", blob);
    });
    const canvas = this.cropper.getCroppedCanvas();
    this.imageDestination = canvas.toDataURL("image/png");
    //let blob = new Blob([this.imageDestination], { type: 'image/png' })
    // let file = new File([blob], 'imageFileName.png', { type: "image/png" });
    //this.coverImage.append('image', file, 'asdf');
    this.croppedImage = file;
  }

  public ngOnInit() {
    if (this.activeCoverImage) {
      this.coverSet = true;
      this.imageDestination = this.activeCoverImage;
    }
  }

  setCoverImage() {
    this.savingEmitter.sendMessage(true);
    this.coverSet = false;
    this.filesSvc
      .fileUpload(this.croppedImage)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((x) => {
        this.coverSet = true;
        this.experienceSvc
          .setCoverImage(this.experienceId, x.result.resources[0].id)
          .pipe(takeUntil(this.destroyed$))
          .subscribe((x) => {
            this.coverImage.emit(this.imageDestination);
            this.savingEmitter.sendMessage(false);
          });
      });
  }

  reset() {
    this.cropper.reset();
    this.createCroppedImage();
  }

  // addToGallery() {
  //   let imageId;
  //   this.loadedImagePointer++;
  //   this.filesSvc.fileUpload(this.croppedImage)
  //     .pipe(takeUntil(this.destroyed$))
  //     .subscribe(x => {
  //       imageId = x.result.resources[0].id;
  //       this.experienceSvc.addImageToGallery(this.experienceId, imageId)
  //         .pipe(takeUntil(this.destroyed$))
  //         .subscribe(y => {
  //           this.galleryImages.push({ image: this.imageDestination, id: imageId });
  //         })
  //     })
  //   this.imageSource = this.loadedImages[this.loadedImagePointer];
  //   this.cropper.replace(this.imageSource);
  // }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
